import { CommonData } from '../common_schema'

export const cboData: CommonData[] = [
  {
    name: 'Auto Analyze QPS',
    mean: 'Stats_autoanalyze_OPS:total.values.mean',
    std: 'Stats_autoanalyze_OPS:total.values.std',
    location: 'TiDB-Details --> Statistics --> Auto Analyze QPS'
  },
  {
    name: 'KV Cursor Operations (For All Analyze Requests)',
    mean: 'Copr_Scan_for_analyze_OPS:total.values.mean',
    std: 'Copr_Scan_for_analyze_OPS:total.values.std',
    location:
      'TiKV-Details  --> Coprocessor Overview --> Total KV Cursor Operations'
  },
  {
    name: 'Total KV Cursor Operations',
    mean: 'Copr_Scan_for_OPS:total.values.mean',
    std: 'Copr_Scan_for_OPS:total.values.std',
    location:
      'TiKV-Details  --> Coprocessor Overview --> Total KV Cursor Operations'
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
